import lazyLoad from 'app/shared-components/util/lazyLoad';

const ProfileApp = lazyLoad(() => import('./ProfileApp'));

const profileAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  helpConfig: {
    query: 'profile',
    tag: 'profile',
    title: 'Profile'
  },
  routes: [
    {
      path: 'apps/profile',
      element: <ProfileApp />,
    },
  ],
};

export default profileAppConfig;
